import React from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { email, required } from 'Utils/FormValidation';
import { SubmitButton } from 'Components/Fields/Buttons';
import { useForm } from 'Hooks/useForm';
import { FormField } from 'Components/HookFormFields/FormField';
import './EmailAlertForm.css';

const EmailAlertForm = ({ onFormSubmit, ctaText }) => {
  const formName = 'emailAlertForm';
  const trackingFields = {};
  const { formFieldProps, submitting, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
    onFormCompletedTrackingFields: () => trackingFields,
  });

  return (
    <form onSubmit={(event) => handleSubmit(event)} className="emailAlertForm">
      <FormField
        name="email"
        type="email"
        label="Email Address"
        component="InputField"
        validate={[required, email]}
        {...formFieldProps}
      />
      <SubmitError error={formError} formName={formName} />
      <SubmitButton text={ctaText} submitting={submitting} />
    </form>
  );
};

export default EmailAlertForm;
